import React from 'react';
import Tooltip from '../Tooltip';
import styles from './StatusIndicator.module.css';

export interface StatusIndicatorProps {
  active: boolean;
  label: string;
  className?: string;
}

const StatusIndicator: React.FC<StatusIndicatorProps> = ({ active, label, className }) => (
  <Tooltip content={label}>
    <span
      className={[
        styles['status-indicator'],
        active ? styles['status-ok'] : styles['status-missing'],
        className,
      ].filter(Boolean).join(' ')}
      aria-label={label}
    >
      <span className="material-symbols-outlined" aria-hidden="true">
        {active ? 'check' : 'close'}
      </span>
    </span>
  </Tooltip>
);

export default StatusIndicator;
